{
  "settings": {
    "language": {
      "label": "Wika",
      "helper": "Piliin ang wika para sa menu, ulat, at iba pang text sa app. Nase-save sa account mo sa lahat ng device.",
      "options": {
        "en": "English",
        "tl": "Tagalog"
      },
      "savedEn": "Naka-set na ang wika sa English.",
      "savedTl": "Naka-set na ang wika sa Tagalog."
    }
  },
  "pages": {
    "taxCalculator": {
      "subtitle": "Sagutan ang eligibility sa BMBE, mga input sa kita, at VAT (kung applicable) para ikumpara ang 8% flat tax, graduated OSD, itemized deductions, at mga kombinasyong may BMBE.",
      "classificationLabel": "Klasipikasyon ng taxpayer",
      "classificationPurelySelfEmployed": "Purong business / self-employed / propesyonal",
      "classificationMixedIncome": "Mixed income earner",
      "grossSalesLabel": "Kabuuang taunang gross sales / resibo",
      "expensesWithReceiptsLabel": "Mga gastos na may valid na resibo",
      "expensesWithReceiptsHint": "Ginagamit lang para sa itemized deduction.",
      "expensesWithoutReceiptsLabel": "Mga gastos na walang resibo",
      "expensesWithoutReceiptsHint": "Hindi ibinabawas sa calculator na ito; gabay lang sa pagpaplano.",
      "withoutReceiptsGuide": "Naglagay ka ng {{amount}} sa gastos na walang resibo. Maaaring mas praktikal ang OSD kapag maraming gastos ang walang opisyal na resibo.",
      "insightFlat8Disqualified": "Hindi ka eligible sa 8% flat rate dahil lumampas ang gross sales sa ₱3,000,000 na VAT threshold.",
      "insightFlat8Wins": "Ang 8% flat tax ang may pinakamababang tinatayang kabuuang buwis para sa iyong mga input.",
      "insightOsdWins": "Inirerekomenda ang OSD dahil may malaking gastos ka na walang resibo. Maaaring mas mura ang awtomatikong 40% na deduction kaysa itemize.",
      "insightItemizedWins": "Inirerekomenda ang itemized dahil ang iyong dokumentadong gastos na may opisyal na resibo ang pinakamabababa sa taxable income.",
      "regimeFlat8Title": "8% Flat Tax",
      "regimeOsdTitle": "Graduated + OSD",
      "regimeItemizedTitle": "Graduated + Itemized",
      "regimeOsdBmbeTitle": "Graduated + OSD + BMBE",
      "regimeItemizedBmbeTitle": "Graduated + Itemized + BMBE",
      "mostRecommended": "Pinakainirerekomenda",
      "disqualifiedShort": "Disqualified",
      "disqualifyVatThreshold": "Hindi eligible — lumampas ang gross sales sa ₱3,000,000 na VAT threshold.",
      "disqualifyBmbeIneligible": "Hindi eligible — hindi natugunan ang BMBE criteria base sa iyong mga sagot.",
      "disqualifyBmbeFlat8Conflict": "Hindi compatible — hindi maaaring pagsamahin ang BMBE income tax exemption sa 8% flat rate.",
      "incomeTaxExemptBmbeLine": "Buwis sa kita: exempt (BMBE)",
      "percentageTaxLine": "Percentage tax ({{rate}}): {{amount}}",
      "percentageTaxExemptLine": "Percentage tax: exempt (8% regime)",
      "outputVatLine": "Output VAT ({{rate}}): {{amount}}",
      "inputVatCreditLine": "Input VAT credit: {{amount}}",
      "netVatLine": "Net VAT na babayaran: {{amount}}",
      "taxableIncomeLine": "Taxable income: {{amount}}",
      "insightVatRegistered": "Lumampas ang gross sales mo sa ₱3,000,000, kaya applicable ang VAT registration. Hindi applicable ang percentage tax sa mga scenario na ito.",
      "insightVatBmbeNote": "Maaari pa ring mag-apply ang BMBE kahit lampas ₱3,000,000 ang sales kung nasa loob ng BMBE limit ang total assets — exempt lang ang BMBE sa income tax, hindi sa VAT.",
      "insightBmbeWins": "Ang graduated method na may BMBE registration ang may pinakamababang tinatayang kabuuang buwis para sa iyong mga input.",
      "insightBmbeAlternative": "Maaaring qualified ka sa BMBE — ikumpara ang mga column na may BMBE para sa posibleng mas mababang income tax.",
      "insightOsdBmbeWins": "Ang Graduated OSD na may BMBE ang may pinakamababang tinatayang kabuuang buwis para sa iyong mga input.",
      "insightItemizedBmbeWins": "Ang Graduated itemized na may BMBE ang may pinakamababang tinatayang kabuuang buwis para sa iyong mga input.",
      "bmbeEligibleNote": "Ang iyong mga sagot ay tumutugma sa basic na BMBE requirements. Exempt ang BMBE sa income tax sa qualified na operasyon pero hindi sa VAT o percentage tax. Kumpirmahin ang registration sa iyong LGU o DTI Negosyo Center.",
      "bmbeIneligibleNote": "Base sa iyong mga sagot sa BMBE, ang mga column na may BMBE ay ipinapakita bilang hindi eligible. Maaari mo pa ring ikumpara ang standard na 8%, OSD, at itemized scenarios.",
      "disclaimer": "Ang mga estimate ay gumagamit ng BIR graduated income tax brackets plus 3% percentage tax sa gross sales para sa graduated regimes na below sa ₱3,000,000 na VAT threshold. Walang percentage tax ang 8% regime. Kumpirmahin ang mga rate (hal. 1% CREATE relief) at eligibility sa iyong accountant.",
      "disclaimerVat": "Ang mga estimate ay gumagamit ng BIR graduated income tax brackets plus net VAT (output VAT minus input VAT credits) kapag lumampas ang gross sales sa ₱3,000,000. Exempt lang ang BMBE sa income tax — applicable pa rin ang VAT. Kumpirmahin ang mga rate at registration status sa iyong accountant.",
      "wizard": {
        "formHeading": "Tax calculator wizard",
        "progressQuestion": "Hakbang {{current}} ng {{total}}",
        "progressPercent": "{{percent}}% tapos na",
        "progressAriaLabel": "Progreso ng tax calculator",
        "bmbeSectionLabel": "Eligibility sa BMBE",
        "incomeSectionLabel": "Mga input sa buwis sa kita",
        "vatSectionLabel": "Mga input sa VAT",
        "classificationHint": "Nakakaapekto ito sa 8% flat tax deduction para sa purely self-employed taxpayers.",
        "grossSalesHint": "Ilagay ang kabuuang taunang gross sales o resibo. Karaniwang VAT-registered kapag lampas ₱3,000,000.",
        "outputVatLabel": "Tinatayang taunang output VAT",
        "outputVatHint": "Karaniwang 12% ng vatable sales (tax-exclusive). May pre-fill na mungkahi mula sa gross sales — ayusin kung iba ang invoices mo.",
        "inputVatLabel": "Tinatayang taunang input VAT credits",
        "inputVatHint": "VAT na maaari mong i-claim mula sa mga binili na may valid na VAT invoice (supplies, rent, services, atbp.)."
      },
      "bmbe": {
        "suggestionTitleGraduated": "Gusto mo bang magbayad ng mas kaunting buwis bilang BMBE?",
        "suggestionSubtitleGraduated": "Tingnan kung maaaring mag-qualify ang negosyo mo bilang BMBE (Barangay Micro Business Enterprise). Ilang mabilis na tanong lang.",
        "suggestionTitleFlat8": "Gusto mo bang i-check ang BMBE eligibility?",
        "suggestionSubtitleFlat8": "Ang BMBE tax benefits ay para sa graduated tax (OSD o itemized), hindi sa 8% flat rate sa iyong resulta.",
        "flat8ReminderTitle": "8% flat tax at BMBE",
        "flat8ReminderBody": "Para magamit ang BMBE benefits, kailangan mong lumipat mula sa 8% patungo sa graduated method. Kumpirmahin ang mga opsyon sa iyong LGU o DTI Negosyo Center adviser bago mag-register.",
        "checkerTitle": "Mabilis na BMBE check",
        "checkerSubtitle": "Isang tanong sa bawat hakbang. Sasabihin namin kung maaaring eligible kang mag-register.",
        "progressQuestion": "Tanong {{current}} ng {{total}}",
        "progressPercent": "{{percent}}% tapos na",
        "progressAriaLabel": "Progreso ng BMBE eligibility",
        "checkEligibilityButton": "I-check ang eligibility ko",
        "pickAnswerHint": "Pumili ng Oo o Hindi para magpatuloy.",
        "answerYes": "Oo",
        "answerNo": "Hindi",
        "reviewTitle": "Ganito ang paghahambing ng iyong mga sagot sa BMBE requirements:",
        "reviewYourAnswer": "Sagot mo: {{answer}}",
        "reviewNeededAnswer": "Kailangan: {{answer}}",
        "successTitle": "Maaaring eligible ka",
        "successSubtitle": "Tumutugma ang iyong mga sagot sa basic na BMBE requirements sa checker na ito.",
        "successMessage": "Susunod na hakbang: bisitahin ang iyong LGU o DTI Negosyo Center para kumpirmahin ang mga dokumento at kumpletuhin ang registration. Maaaring magbago ang mga patakaran, kaya laging i-verify sa opisyal na adviser bago mag-file.",
        "noticeTitle": "Hindi eligible base sa iyong mga sagot",
        "noticeSubtitle": "May kahit isang sagot na hindi tumutugma sa karaniwang BMBE requirements.",
        "noticeYourAnswer": "Sagot mo: {{answer}}",
        "noticeRequiredAnswer": "Karaniwang kailangan: {{answer}}",
        "noticeContactPrefix": "May tanong? Bisitahin ang pinakamalapit na Negosyo Center:",
        "noticeContactLinkLabel": "DTI Negosyo Center contact page",
        "noticeContactOr": "o mag-email sa",
        "noticeThankYou": "Salamat.",
        "okButton": "Naintindihan ko",
        "criteria": {
          "totalAssets": {
            "headline": "Laki ng negosyo",
            "question": "Lampas ba sa ₱3 milyon o higit pa ang kabuuang assets ng negosyo mo?",
            "help": "Isama ang kagamitan, inventory, at tools para sa negosyo. Huwag isama ang lupang pinagtatyuan ng tindahan, opisina, o planta. Sumagot ng Oo kung lampas sa ₱3 milyon ang kabuuan.",
            "failureExplain": "Para sa micro businesses ang BMBE na may total assets na ₱3 milyon o mas mababa (hindi kasama ang lupa). Dahil sinagot mong lampas sa limit ang assets mo, hindi mo natutugunan ang BMBE requirement na ito."
          },
          "barangayBased": {
            "headline": "Lokal na operasyon",
            "question": "Sa iyong barangay o lungsod ba pangunahing tumatakbo ang negosyo mo?",
            "help": "Karaniwang nangangahulugan ito na karamihan ng mga manggagawa ay malapit, gumagamit ka ng lokal na skills o materyales, o nananatili ang trabaho sa iyong lungsod o munisipalidad (LGU).",
            "failureExplain": "Dapat barangay-based ang BMBE businesses — pangunahing tumatakbo sa lokal na lugar gamit ang lokal na manggagawa, skills, o materyales. Sumagot kang Hindi, kaya maaaring hindi mag-qualify ang negosyo mo sa patakarang ito."
          },
          "largeEnterprise": {
            "headline": "Independence",
            "question": "Branch, subsidiary, o opisina ba ang negosyo mo na kontrolado ng malaking kumpanya?",
            "help": "Sumagot ng Oo lang kung may malaking korporasyon na nagmamay-ari o kumokontrol kung paano mo pinapatakbo ang negosyo. Para sa BMBE, karaniwang dapat Hindi ang sagot.",
            "failureExplain": "Sinagot mong kinokontrol ng malaking kumpanya ang negosyo mo. Para sa independent micro businesses ang BMBE registration, hindi sa mga branch, subsidiary, o opisina ng malalaking korporasyon."
          },
          "licensedProfessional": {
            "headline": "Uri ng serbisyo",
            "question": "Mula ba sa regulated/licensed professional services ang pangunahing pinagkukunan ng kita mo (hal. abogado, CPA, doktor, parmasyutiko)?",
            "help": "Sumagot ng Oo kung mula sa regulated professions ang pangunahing pinagkukunan ng kita mo. Maraming BMBE applicant ang mga tindahan, trader, o general services at sumasagot ng Hindi.",
            "failureExplain": "Sinagot mong mula sa regulated profession ang pangunahing pinagkukunan ng kita mo. Karaniwang hindi eligible para sa BMBE ang mga negosyong nakasentro sa batas, medisina, accounting, parmasya, at katulad na regulated services."
          }
        }
      }
    }
  },
  "components": {
    "TransactionWizard": {
      "TransactionWizard": {
        "backToTransactions": "Bumalik sa Transactions",
        "validationNoEntries": "Magdagdag ng kahit isang entry",
        "validationNotBalanced": "Hindi balanse ang transaction",
        "eachCategoryOnce": "Isang beses lang maaaring gamitin ang bawat category sa isang transaction.",
        "editCategory": "I-edit ang Category",
        "selectCategory": "Pumili ng Category",
        "debitOrCredit": "Debit o Credit",
        "enterAmount": "Ilagay ang Halaga",
        "reviewTransaction": "Suriin ang Transaction",
        "titleSubtitle": "Manu-manong magtala ng debit o credit transaction gamit ang mga napapasadyang category at halaga.",
        "entryCountOne": "{{count}} entry ang nadagdag",
        "entryCountMany": "{{count}} entries ang nadagdag",
        "skipToReview": "Laktawan at Suriin",
        "addAnother": "Magdagdag Pa",
        "review": "Suriin",
        "suggestions": "Mga mungkahi",
        "useForeignCurrency": "Gumamit ng foreign currency",
        "searchCurrency": "Maghanap ng currency",
        "reviewTransactions": "Suriin ang mga Transaction",
        "addDebitQuickRow": "Magdagdag ng Debit",
        "addCreditQuickRow": "Magdagdag ng Credit",
        "quickAddLineHint": "Magsimula ng bagong line bilang debit o credit.",
        "noEntriesYetHint": "Wala pang entries. Idagdag ang unang line para makapagsimula.",
        "quickAddCloseAriaLabel": "Isara ang quick add",
        "quickAddChangeCategory": "Palitan",
        "quickAddDiscardButton": "Kanselahin",
        "quickAddCancelButton": "Tapos",
        "underParent": "Nasa ilalim ng {{parent}}",
        "createCategory": "Gumawa ng category",
        "noDate": "Walang petsa",
        "description": "Description",
        "optional": "opsyonal",
        "noDescription": "Walang description",
        "attachmentCountOne": "attachment (1)",
        "attachmentCountMany": "attachments ({{count}})",
        "saving": "Sine-save..."
      }
    }
  }
}
